import { posthog, getCommonTrackingProperties } from '@/composables/usePosthog'
import { trackProductAdd } from '@/utils/productAnalytics'

export function trackCartLineQuantityChange(
  store,
  { from = 0, to = 0, isUpsell = false, productId, productName } = {}
) {
  const previous = Number(from) || 0
  const next = Number(to) || 0

  if (next > previous) {
    trackProductAdd(store, {
      isUpsell,
      quantity: next - previous,
      productId,
      productName,
      eventName: 'added_incremental_cart_item',
      eventCount: next
    })
    return
  }

  if (next < previous) {
    const vuex = store?.$store || store
    const eventName = isUpsell ? 'upsells_removed_incremental_cart_item' : 'removed_incremental_cart_item'
    posthog.capture(eventName, { ...(vuex ? getCommonTrackingProperties(vuex) : {}), count: next })
  }
}
